// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// model imports
import { UserNameDisplayResultDto } from '../../../../_models/user-name-display-result-dto';

@Component({
    selector: 'app-multi-user-bio-links',
    templateUrl: './multi-user-bio-links.component.html',
    styleUrls: ['./multi-user-bio-links.component.scss']
})
export class MultiUserBioLinksComponent implements OnInit {
    @ViewChild('userPopup', { static: false }) userPopup: DxPopupComponent;

    @Input() users: Array<UserNameDisplayResultDto> = [];
    @Input() communityId: number;
    @Input() title: string;

    @Output() onClose = new EventEmitter<void>();

    visible = false;
    noDataText: string;

    ngOnInit() {
        this.show();
        this.noDataText = `No ${this.title} Users`;
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        this.userPopup.instance.repaint();
    }

    onHidden(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
